import { Avatar } from '@material-ui/core';
import React from 'react';

import { OrderActionType } from '@/components/modules/OrderActivity/types/OrderActionType';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const ActionIcon: React.FC<{ type: OrderActionType; size: 'small' | 'large' }> = ({ type, size }) => {
  const { palette } = useCustomTheme();

  const getIconName = () => {
    switch (type) {
      case OrderActionType.order:
        return 'shopping_cart';
      case OrderActionType.payout:
        return 'payments';
      case OrderActionType.capture:
        return 'local_shipping';
      case OrderActionType.refund:
        return 'arrow_back';
    }
  };
  const iconName = getIconName();

  return (
    <>
      <Avatar
        style={{
          background: palette.minor.main,
          width: size === 'small' ? 28 : 36,
          height: size === 'small' ? 28 : 36,
          color: palette.minor.contrastText,
        }}
      >
        <i className={'material-icons-outlined'} style={{ fontSize: size === 'small' ? 18 : 20 }}>
          {iconName}
        </i>
      </Avatar>
    </>
  );
};
